import type DepartmentDataService from '../commons/data-services/department.data-service';
import type LocationDataService from '../commons/data-services/location.data-service';
import type {ViewableDepartment} from 'typings/portaro.fe.types';
import type {Department} from 'typings/portaro.be.types';

export class KpDepartmentsPresenter {
    public static presenterName = 'kpDepartmentsPresenter';

    /*@ngInject*/
    constructor(private departmentDataService: DepartmentDataService, private locationDataService: LocationDataService) {
    }

    public async getDepartments(): Promise<ViewableDepartment[]> {
        const departments: Department[] = await this.departmentDataService.getAll();
        return Promise.all(departments.map(async (department) => {
            return {
                ...department,
                parent: department.root ? null : departments.find((value) => value.id === department.parentId),
                locations: await this.locationDataService.getAllByDepartment(department),
            } as ViewableDepartment
        }));
    }


}